(function () {
    function updateTimer(countDownDate) {
        var x = setInterval(function () {
            // Get today's date and time
            let now = new Date().getTime();

            // Find the distance between now and the count down date
            let distance = countDownDate - now;

            // Time calculations for days, hours, minutes and seconds
            let days = Math.floor(distance / (1000 * 60 * 60 * 24));
            let hours = Math.floor(
                (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            );
            let minutes = Math.floor(
                (distance % (1000 * 60 * 60)) / (1000 * 60)
            );
            let seconds = Math.floor((distance % (1000 * 60)) / 1000);

            let countdown = document.querySelector("#countdown");
            let daysEl = countdown.querySelector("#days");
            let hoursEl = countdown.querySelector("#hours");
            let minutesEl = countdown.querySelector("#minutes");
            let secondsEl = countdown.querySelector("#seconds");

            let todaySpans = daysEl.querySelector("span");
            let hourSpans = hoursEl.querySelector("span");
            let minuteSpans = minutesEl.querySelector("span");
            let secondSpans = secondsEl.querySelector("span");

            if (days >= 10) {
                todaySpans.textContent =
                    days.toString().charAt(0) + days.toString().charAt(1);
            } else {
                todaySpans.textContent = "0" + days;
            }

            if (hours >= 10) {
                hourSpans.textContent =
                    hours.toString().charAt(0) + hours.toString().charAt(1);
            } else {
                hourSpans.textContent = "0" + hours;
            }

            if (minutes >= 10) {
                minuteSpans.textContent =
                    minutes.toString().charAt(0) + minutes.toString().charAt(1);
            } else {
                minuteSpans.textContent = "0" + minutes;
            }

            if (seconds >= 10) {
                secondSpans.textContent =
                    seconds.toString().charAt(0) + seconds.toString().charAt(1);
            } else {
                secondSpans.textContent = "0" + seconds;
            }

            // If the count down is over, write some text
            if (distance < 0) {
                clearInterval(x);
                // document.getElementById("demo").innerHTML = "EXPIRED";
            }
        }, 1000);
    }

    document.addEventListener("DOMContentLoaded", function () {
        const countdown = document.querySelector("#countdown");
        const fecha = countdown ? countdown.dataset.fecha : null;
        updateTimer(new Date(fecha || "2025-08-01 09:30:00").getTime());
    });
})();
